import vheader from './header.vue'

export default  vheader


// WEBPACK FOOTER //
// ./src/components/header/index.js